import * as THREE from "three";

export function createWaveUpdater(uniforms) {
  const worldPosition = new THREE.Vector3();
  const localPosition = new THREE.Vector3();
  let center = null;
  let liquid = null;

  return {
    attach({ centerWaves, movingLiquid }) {
      center = centerWaves;
      liquid = movingLiquid;
    },
    update(delta) {
      if (!center) return;

      center.getWorldPosition(worldPosition);
      uniforms.center.value.set(worldPosition.x, worldPosition.z);

      if (liquid) {
        localPosition.copy(worldPosition);
        liquid.worldToLocal(localPosition);
        uniforms.centerLocal.value.set(localPosition.x, localPosition.z);
      }

      uniforms.time.value += delta;
    },
  };
}
